export default "__VITE_ASSET__28ec8abc__"